<h1 id="dialog_title_lbl" mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content class="mat-subheading-1">
	<p id="dialog_message_lbl" class="mat-body">{{ message }}</p>
</div>
<div mat-dialog-actions fxLayout fxLayoutAlign="end center">
	<button id="dialog_okay_btn" type="button" mat-button (click)="dialogRef.close(true)" cdkFocusInitial>Okay</button>
</div>